// extracted by mini-css-extract-plugin
export var menuIcon = "_ud-0";
export var menuIconInline = "_ud-1";